import dayjs from 'dayjs';
import i18next, { i18n as I18n } from 'i18next';

import { i18n as i18nConfigured } from '@src/configs/i18n.configs';
import {
  LOCALE_CODE,
  LOCALES,
  LONG_MONTH_TRANSLATIONS_KEY,
  WEEKDAYS_SHORT_TRANSLATIONS_KEY,
} from '@src/constants/locales.constants';
import {
  ILanguageOption,
  ILocaleCode,
} from '@src/interfaces/locale.interfaces';

export const translateAMPM =
  (locale: string) => (h: number, m: number, isUpperCase: boolean) => {
    const data = i18next.t(h > 12 ? 'global.PM' : 'global.AM', locale);
    return isUpperCase ? data.toUpperCase() : data;
  };

export const dayjsUpdateLocale = ({ language, t }: I18n) => {
  dayjs.locale(language);

  const localeConfig: Record<string, unknown> = {
    months: LONG_MONTH_TRANSLATIONS_KEY.map((month) =>
      t(month, { ns: 'default' }),
    ),
    weekdaysShort: WEEKDAYS_SHORT_TRANSLATIONS_KEY.map((weekday) =>
      t(weekday, { ns: 'default' }),
    ),
    meridiem: translateAMPM(language),
  };

  if (language === LOCALE_CODE.NL) {
    localeConfig.weekStart = 7;
  }

  dayjs.updateLocale(language, localeConfig);
};

export const onChangeLanguage = async (lng: string) => {
  if (i18nConfigured.language !== lng) {
    await i18nConfigured.changeLanguage(lng);
    dayjs.locale(lng);
  }
};

export const getCurrentLocaleOption = (
  locale?: ILocaleCode | string,
): ILanguageOption => {
  const checkedLocale = (locale ||
    i18nConfigured.language ||
    LOCALE_CODE.EN) as ILocaleCode;
  return LOCALES[checkedLocale] || LOCALES[LOCALE_CODE.EN];
};

export const getCurrentLocaleOptionByRegion = (
  region?: string,
): ILanguageOption => {
  const localeOption = Object.values(LOCALES).find(
    (option) => option.region === region?.toUpperCase(),
  );

  return localeOption || LOCALES[LOCALE_CODE.EN];
};

export const toNormalizeLocale = (lang: ILocaleCode | string) => {
  const { region } = getCurrentLocaleOption(lang);
  return region ? `${lang}_${region}` : lang;
};
